import React from "react";
import { Container, PageContent, Page } from "./style";
import { SideBar } from "./components/sideBar/index";

interface ParentCompProps {
  childComponent?: React.ReactNode;
}

export const Painel: React.FC<ParentCompProps> = (props) => {
  const { childComponent } = props;
  return (
    <>
      <Container>
        <SideBar />
        <Page>
          <PageContent>{childComponent}</PageContent>
        </Page>
      </Container>
    </>
  );
};
